export default __webpack_public_path__ + "122a852498277589db7b543bd91d4aa0.svg";